import * as React from 'react';
import { isSameMonth } from 'date-fns';
import { useDayPicker } from '..';
import { getInitialMonth } from './utils/getInitialMonth';
/** Controls the navigation state. */
export function useNavigationState() {
    var context = useDayPicker();
    var initialMonth = getInitialMonth(context);
    var _a = React.useState(initialMonth), month = _a[0], setMonth = _a[1];
    var goToMonth = function (date) {
        if (context.disableNavigation)
            return;
        setMonth(date);
    };
    // Update month if updated from context.
    React.useEffect(function () {
        // TODO: return void also if `context.defaultMonth`?
        if (!context.month)
            return;
        if (isSameMonth(context.month, month))
            return;
        setMonth(context.month);
    }, [context.month]);
    return [month, goToMonth];
}
//# sourceMappingURL=useNavigationState.js.map